var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Bell"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.5 13C6.875 13 7.37868 13 8 13C8.62132 13 9.125 13 9.5 13C9.5 14.2 9.125 15 8 15C6.875 15 6.5 14.2 6.5 13Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.38939 2.08038C5.42365 1.39115 6.6891 1 7.93333 1C9.16627 1 10.5673 1.3851 11.6106 2.08038C12.6492 2.77253 13.5 3.85085 13.5 5.24V10H12.5V5.24C12.5 4.29914 11.9268 3.49281 11.0561 2.91254C10.1916 2.33647 8.98731 2 7.93333 2C6.89063 2 5.81747 2.33042 4.94394 2.91254C4.07319 3.49281 3.5 4.29914 3.5 5.24V10H2.5V5.24C2.5 3.85085 3.35076 2.77253 4.38939 2.08038Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.75359 10.7079C2.60231 10.8162 2.5 10.9756 2.5 11.25C2.5 11.5244 2.60231 11.6838 2.75359 11.7921C2.92669 11.9161 3.20709 12 3.57895 12H12.4211C12.7929 12 13.0733 11.9161 13.2464 11.7921C13.3977 11.6838 13.5 11.5244 13.5 11.25C13.5 10.9756 13.3977 10.8162 13.2464 10.7079C13.0733 10.5839 12.7929 10.5 12.4211 10.5H3.57895C3.20709 10.5 2.92669 10.5839 2.75359 10.7079ZM2.17134 9.89489C2.5697 9.6096 3.07877 9.5 3.57895 9.5H12.4211C12.9212 9.5 13.4303 9.6096 13.8287 9.89489C14.2489 10.1958 14.5 10.6614 14.5 11.25C14.5 11.8386 14.2489 12.3042 13.8287 12.6051C13.4303 12.8904 12.9212 13 12.4211 13H3.57895C3.07877 13 2.5697 12.8904 2.17134 12.6051C1.75115 12.3042 1.5 11.8386 1.5 11.25C1.5 10.6614 1.75115 10.1958 2.17134 9.89489Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.c47f7238163528f157a6864c848f0b07.svg";
export { ForwardRef as ReactComponent };